module.exports = __webpack_public_path__ + "static/media/Khayyam Lasi.1e2b2bbd.png";